import {observer} from 'mobx-react';
import React from 'react';
import {SidebarAdministrator} from './parts/SidebarAdministrator';
import {SidebarContentManager} from './parts/SidebarContentManager';
import {SidebarStudent} from './parts/SidebarStudent';
import {SidebarTeacher} from './parts/SidebarTeacher';
import {SidebarStore} from './SidebarStore';

@observer
export class SidebarBlock extends React.Component {
  store: SidebarStore;

  constructor(props: any) {
    super(props);
    this.store = new SidebarStore();
  }

  render() {
    const store = this.store;
    return (
      <div className="sidebar-block">
        {
          store.showAdministratorMenu &&
          <SidebarAdministrator store={store}/>
        }

        {
          store.showContentManagementMenu &&
          <SidebarContentManager store={store}/>
        }

        {
          store.showTeacherMenu &&
          <SidebarTeacher store={store}/>
        }

        {
          store.showStudentMenu &&
          <SidebarStudent store={store}/>
        }
      </div>);
  }

  componentWillUnmount() {
    this.store.dispose();
  }
}
